
 



// const intervalID = setInterval(function() {
//     var fromDate = new Date().addDays(5);
//     if (fromDate.getDay() === 6 || fromDate.getDay() === 0) {
//         fromDate = new Date(fromDate.setDate(fromDate.getDate() + (fromDate.getDay() === 6 ? 2 : 1)));
//     }
//     var toDate = new Date().addDays(10);
//     if (toDate.getDay() === 6 || toDate.getDay() === 0) {
//         toDate = new Date(toDate.setDate(toDate.getDate() + (toDate.getDay() === 6 ? 2 : 1)));
//     }
//     document.getElementById('fromDateQuick').innerHTML = fromDate.toString('dddd MMMM dS');
//     document.getElementById('toDateQuick').innerHTML = toDate.toString('dddd MMMM dS');
  

// }, 500);



// const items = document.querySelectorAll('.product-cart-item--container .product-cart-item');
// items.forEach(function(item, index) {
//   console.log(index,'itemsitemsitemsitems')
//   const intervalIDS = setInterval(function() {
//     var fromDate = new Date().addDays(5);
//     if (fromDate.getDay() === 6 || fromDate.getDay() === 0) {
//         fromDate = new Date(fromDate.setDate(fromDate.getDate() + (fromDate.getDay() === 6 ? 2 : 1)));
//     }
//     var toDate = new Date().addDays(10);
//     if (toDate.getDay() === 6 || toDate.getDay() === 0) {
//         toDate = new Date(toDate.setDate(toDate.getDate() + (toDate.getDay() === 6 ? 2 : 1)));
//     }
//     document.getElementById(`fromDateQuick${index}`).innerHTML = fromDate.toString('dddd MMMM dS');
//     document.getElementById(`toDateQuicks${index}`).innerHTML = toDate.toString('dddd MMMM dS');
  

// }, 500);
   
// });



 
 //   $('.sku_search').change(function() {
 //    console.log( 'searchTerm')
 //    this.onChange(); 
 //  });

 // onChange() {
 //    const searchTerm = this.getQuery();

 //    if (!searchTerm.length) {
 //      this.container.classList.remove('active');
 //      return;
 //    }
 //    this.container.classList.add('active');
 //    this.getSearchResults(searchTerm);
 //  }

 //  getSearchResults(searchTerm) {
 //    const queryKey = searchTerm.replace(" ", "-").toLowerCase();

 //    this.predictiveSearchResults.classList.add('loading');

 //    fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product,collection,article,query&${encodeURIComponent('resources[limit]')}=6&section_id=predictive-search`)
 //      .then((response) => {
 //        this.predictiveSearchResults.classList.remove('loading');
 //        if (!response.ok) {
 //          var error = new Error(response.status);
 //          throw error;
 //        }

 //        return response.text();
 //      })
 //      .then((text) => {
 //        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;

 //        this.renderSearchResults(resultsMarkup);
 //      })
 //      .catch((error) => {
 //        throw error;
 //      });
 //  }


document.addEventListener('DOMContentLoaded', function () {
  // Only run on product template pages
  if (!document.body || document.body.id !== 'product') return;
    $('.sizeSelect').change(function() {
    $(this).blur();
  });
  
});
